module.exports = __webpack_public_path__ + "./fonts/HelveticaNeue-SemiBold.ttf";